// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_14Rrp_qbkCU4DhxdBYlaSl","Table":"_3PQgexxm44BnmL_zWinqRL","CellLeft":"soI7VENlKZE2GnMmUp1fc","Success":"_1ePEcLESJSYnUWYqTUQrHF","Decline":"_2lNbclOY5TYOMEMNz-WIri","MobileList":"_3cn_kMQpze5LIcEs4UDxis","Empty":"_35dPrzYeFDxxaHBWS2iXmY","EmptyRow":"_1rndDsPtDmXexxJONbmOgc","DesktopTable":"_3sWqHtonmGx6sMhUNeGasy","MobileCard":"slXGcfCo9QVQ9w4ZVV0r_","MobileHeader":"_3S9d1zhfNnH1yA3piJw5Kt","MobileCountry":"_9uUVDrC2EA9Fdkwz_eJAl","MobileTurnover":"_3onta4Bjmhmf1f0lV9PzFF","MobileStats":"_3d5BVSwtKS6x-hmnBQtawl"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Charts/CountryTop/styles.module.css
// module id = 102
// module chunks = 0